import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/fcb_small.mp4";
import projImg2 from "../assets/img/sw_small.mp4";
import projImg3 from "../assets/img/fida_small.mp4";
import projImg5 from "../assets/img/hra.webp";
import projImg6 from "../assets/img/sandbox.webp";
import projImg7 from "../assets/img/chopshop.webp";
import projImg8 from "../assets/img/POS.webp";
import projImg10 from "../assets/img/hra-site.webp";

import get_top from '../assets/modals/get_top.png';
import get_last from '../assets/modals/get_last.png';
import graph from '../assets/modals/graph.png';
import fcb_rank_card from '../assets/modals/fcb_rank_card.png';
import wr from '../assets/modals/wr.png';
import sw_bl from '../assets/modals/sw_bl.png';
import get_all from '../assets/modals/get_all.png';
import rank_card from '../assets/modals/rank_card.png';
import inrole from '../assets/modals/inrole.png';

const fcb = [get_top, get_last, fcb_rank_card, wr];
const sw = [sw_bl];
const fc = [get_all, graph, rank_card, inrole];

export const Projects = () => {

  const projects = [
    {
      title: <a target="_blank" href="https://discord.com/api/oauth2/authorize?client_id=977343050651168788&permissions=439429229680&scope=applications.commands%20bot" rel="noreferrer" style={{ color: 'white', textDecoration: 'none' }}>ForzaCompBot</a>,
      description: "Surfaces Forza Horizon 3, 4, and 5 World Records via simple Discord commands. Built an API wrapper around a community-maintained Google Sheet to deliver user-friendly race data. Includes ELO ranking features from FIDA Core.",
      imgUrl: projImg1,
      images: fcb
    },
    {
      title: "StreetBot",
      description: "Manages the Street Wars Discord server and automates the Blacklist PvP battle system for the Forza Horizon Street Wars community. Handles race tracking, rankings, and fairness enforcement.",
      imgUrl: projImg2,
      images: sw
    },
    {
      title: "FIDA Core",
      description: "An ELO ranking system Discord bot serving over 20,000 users across FIDA communities. Tracks progression, medals, and leaderboards — supporting a full competitive experience.",
      imgUrl: projImg3,
      images: fc
    },
    {
      title: "HRA Submission Bot",
      description: "A Discord bot for the Forza Horizon Racing Academy that uses Optical Character Recognition (OCR) to parse race time submissions from screenshots and automatically assign member roles based on results.",
      imgUrl: projImg5,
    },
    {
      title: "Sandbox Bot",
      description: "A personal all-in-one Discord bot featuring daily weather reports, Canvas LMS announcements, assignment notifications, file conversion utilities, and a general development sandbox.",
      imgUrl: projImg6,
    },
  ];

  const app_projects = [
    {
      title: "ChopShop",
      description: "A companion shopping app that calculates the fastest route through a store based on a user's shopping list — reducing time spent navigating large grocery stores.",
      imgUrl: projImg7,
    },
    {
      title: "Pizza Shop POS",
      description: "A full-stack Java desktop application — a fully featured point-of-sale system built for cashier workflows, including order management, item lookup, and transaction handling.",
      imgUrl: projImg8,
    },
  ];

  const web_projects = [
    {
      title: <a target="_blank" href="https://horizonracingacademy.com/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">Horizon Racing Academy</a>,
      description: "A WordPress site for a virtual racing academy focused on teaching racecraft. Built in collaboration with Cast Haste.",
      imgUrl: projImg10,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col xs={12}>
            <h2>Projects</h2>
            <p>A selection of projects spanning Discord bots, desktop applications, and web development — built primarily with Python, Java, and React.</p>
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                <Nav.Item>
                  <Nav.Link eventKey="first">Discord</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Apps</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Websites</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content id="slideInUp">
                <Tab.Pane eventKey="first">
                  <Row>
                    {projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                  <p>Integrations include Google Sheets API, Pandas, asynchronous Python, ELO management, role systems, inter-server communication, and scheduled scripts.</p>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Row>
                    {app_projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                  <p>These projects pushed complexity in data structures, language design, and real-time data — all areas with strong potential for future development.</p>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <Row>
                    {web_projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Projects;
